import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Container, Breadcrumb, Modal, Accordion } from "react-bootstrap";
import { MyApi } from "../MyApi";
import useSEO from "../hooks/useSEO";

export default function ToursDetails({ setting }) {
  const { categorySlug, slug } = useParams();

  const [showModal, setShowModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const [tour, setTour] = useState(null);
  const [gallery, setGallery] = useState([]);
  const [faq, setFaq] = useState([]); // ✅ FAQ STATE

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const openModal = (index) => {
    setActiveIndex(index);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  // 🔹 API CALL
  useEffect(() => {
    const fetchTour = async () => {
      try {
        const res = await axios.get(
          `${MyApi.BASE_URL}tour-details/${categorySlug}/${slug}`,
          {
            headers: { Authorization: MyApi.SECRET_KEY },
          }
        );

        if (res.data.status) {
          setTour(res.data.data);
          setGallery(res.data.gallery || []);
          setFaq(res.data.faq || []); // ✅ SET FAQ
        } else {
          setError(res.data.message || "Tour not found");
        }
      } catch (err) {
        console.error(err);
        setError("API request failed");
      } finally {
        setLoading(false);
      }
    };

    fetchTour();
  }, [categorySlug, slug]);

  // 🔹 SEO
  useSEO({
    title: tour?.meta_title || tour?.productheading || "Tour Details",
    description: tour?.meta_description || tour?.productshortcontent || "",
    keywords: tour?.meta_tags || "",
    canonical: window.location.href,
    ogImage: tour?.image_url || "",
  });

  if (loading) return <p className="text-center py-5">Loading...</p>;
  if (error) return <p className="text-center text-danger">{error}</p>;

  return (
    <>
      {/* 🔹 Breadcrumb */}
      <div className="BreadcrumbStyle">
        <Container>
          <h1>{tour.productname}</h1>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item
              linkAs={Link}
              linkProps={{ to: `/services/${categorySlug}` }}
            >
              {categorySlug.replace(/-/g, " ")}
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
              {tour.productname}
            </Breadcrumb.Item>
          </Breadcrumb>
        </Container>
      </div>

      {/* 🔹 Details */}
      <div className="pageStyle">
        <Container>

          {/* Image */}
          {tour.image_url && (
            <img
              src={tour.image_url}
              alt={tour.productname}
              className="img-fluid rounded-4 mb-4"
            />
          )}

          {/* Content */}
          <div
            dangerouslySetInnerHTML={{ __html: tour.productcontent }}
          />

          {/* Buttons */}
          <div className="d-flex gap-2 my-3">
            <a href={`tel:${setting?.mobile}`} className="btn btn-success">
              Call
            </a>

            <a
              href={`https://wa.me/919569234541?text=${encodeURIComponent(
                `Hi, I want details about ${tour.productname}`
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-danger"
            >
              Book Now
            </a>

            <Link to="/contact-us" className="btn btn-primary">
              Enquire
            </Link>
          </div>

          {/* 🔹 Gallery */}
          {gallery.length > 0 && (
            <div className="mt-4">
              <h4>{tour.productname} Gallery</h4>
              <div className="row">
                {gallery.map((img, index) => (
                  <div className="col-6 col-md-3 mb-3" key={index}>
                    <img
                      src={img.image_url}
                      alt=""
                      className="img-fluid rounded"
                      onClick={() => openModal(index)}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* 🔥 FAQ SECTION */}
         {/* 🔥 FAQ SECTION */}
{faq.length > 0 && (
  <div className="mt-5">
    <h4>{tour.productname} FAQs</h4>

    <Accordion defaultActiveKey="0">
      {faq.map((item, index) => (
        <Accordion.Item eventKey={index.toString()} key={index}>
          
          <Accordion.Header>
            {item.questions || item.question}
          </Accordion.Header>

          <Accordion.Body>
            <div
              dangerouslySetInnerHTML={{
                __html: item.answers || item.answer,
              }}
            />
          </Accordion.Body>

        </Accordion.Item>
      ))}
    </Accordion>
  </div>
)}

        </Container>
      </div>

      {/* 🔹 Modal */}
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Body className="text-center">
          <img
            src={gallery[activeIndex]?.image_url}
            alt=""
            className="img-fluid"
          />
        </Modal.Body>
      </Modal>
    </>
  );
}